export enum ProjectFormTabType {
  GENERAL = "GENERAL",
  TEAM = "TEAM",
  PRICES = "PRICES",
  NOTES = "NOTES",
  CLARIFICATION_REQUEST = "CLARIFICATION_REQUEST"
}
